import React from "react";
import LegalPage from "@/components/LegalPage";
import { useTranslation } from "@/lib/i18n";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <LegalPage
      title={t("legal.terms.title")}
      lastUpdated={t("legal.terms.last_updated")}
      testId="terms-page"
      intro={t("legal.terms.intro")}
      sections={[
        { heading: t("legal.terms.s1_h"), body: t("legal.terms.s1_b") },
        { heading: t("legal.terms.s2_h"), body: t("legal.terms.s2_b") },
        { heading: t("legal.terms.s3_h"), body: t("legal.terms.s3_b") },
        { heading: t("legal.terms.s4_h"), body: t("legal.terms.s4_b") },
        { heading: t("legal.terms.s5_h"), body: t("legal.terms.s5_b") },
        { heading: t("legal.terms.s6_h"), body: t("legal.terms.s6_b") },
      ]}
    />
  );
}
